/* src/app/front-layout/consortiums/page-w11plus/page-w11plus.component.css */
.cs-head {
  margin-top: 100px;
  width: 100%;
  height: 150px;
  background-image: url(/assets/images/cs_bg.jpg);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cs-head h1 {
  font-size: 55px;
  font-weight: 600;
  color: #0077b6;
}
.section-1 {
  display: flex;
  padding: 20px;
  margin: 20px;
  background-color: #fcfcfc;
  border-radius: 10px;
  gap: 10px;
}
.section-1 h1 {
  color: #0077b6;
  font-weight: bold;
  margin-bottom: 20px;
}
.section-1 p {
  font-size: 18px;
}
.section-1 img {
  width: 40%;
  object-fit: cover;
  border-radius: 15px;
}
.sub-1 {
  width: 60%;
  padding: 10px;
  display: flex;
  flex-direction: column;
}
.strip-1 {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 25px;
  background-color: #f7f7f7;
}
.btn-container {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 25px;
}
.btn-container button {
  padding: 10px 20px;
  border: none;
  border-radius: 30px;
  background-color: #0077b6;
  color: #fff;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  transition: all;
}
.btn-container button:hover {
  background-color: #363636;
  color: #1d95c5;
}
.sep-line {
  margin-top: 25px;
  width: 100%;
  height: 5px;
  background-color: #0077b6;
  margin-bottom: 25px;
}
@media (max-width: 768px) {
  .cs-head {
    height: 120px;
    margin-top: 80px;
  }
  .cs-head h1 {
    font-size: 32px;
    padding: 0 15px;
    text-align: center;
  }
  .section-1 {
    flex-direction: column;
    margin: 10px;
    padding: 15px;
  }
  .section-1 img {
    width: 100% !important;
    order: 1;
    max-height: 250px;
    margin-bottom: 15px;
  }
  .sub-1 {
    width: 100% !important;
    order: 2;
    padding: 0;
  }
  .section-1 h1 {
    font-size: 24px;
    margin-bottom: 15px;
  }
  .section-1 p {
    font-size: 16px;
    text-align: justify;
  }
  ul,
  ol {
    padding-left: 20px;
  }
  ol[style*=circle] {
    padding-left: 30px;
  }
}
@media (max-width: 480px) {
  .cs-head {
    height: 100px;
  }
  .cs-head h1 {
    font-size: 28px;
  }
  .section-1 h1 {
    font-size: 22px;
  }
  .section-1 p {
    font-size: 15px;
  }
  .section-1 img {
    max-height: 200px;
  }
  .strip-1 {
    align-items: center;
  }
  .strip-1 h3 {
    font-size: 22px;
    text-align: center;
  }
  .btn-container {
    flex-direction: column;
    align-items: center;
  }
}
/*# sourceMappingURL=page-w11plus.component.css.map */
